// src/ProductList.js
import React from 'react';
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useKeycloak} from "@react-keycloak/web";
import BuyButton from "./BuyButton";
import VippsLogoHorizontal from "../logos/VippsLogoHorizontal";

const GET_PRODUCTS = gql`
    {
        products {
            product {
                title
                sku
                displayPrice
            }
            quantity
        }
    }
`;


const ProductsAvailableForPurchase = (props) => {
    const {keycloak, initialized} = useKeycloak();
    const {loading, error, data, previousData} = useQuery(GET_PRODUCTS,  {
        skip: !initialized || !keycloak.authenticated || !keycloak.token,
        pollInterval: keycloak.authenticated ? 5000 : 0,
        notifyOnNetworkStatusChange: false,
    });

    const resolvedData = data ?? previousData;

    if (loading && !resolvedData) return <p>Loading...</p>;
    if (error && !resolvedData) return <p>Error: {error.message}</p>;
    if (!resolvedData) return null;

    const products = resolvedData.products;

    function getPl() {
        return <div>
            {products.map((item) => (
                <BuyButton key={item.product.sku}
                           className="membership-buy-button"
                           sku={item.product.sku}
                           buttonText={"Kjøp " + item.product.title + ". Pris: " + item.product.displayPrice}/>
            ))}
        </div>;
    }

    return (
        <div>

            <div>
                {products.length > 0 ? (
                    <div>
                        <h2>Tilgjengelige medlemskap</h2>
                        {getPl(products)}
                        <p>Betal med <VippsLogoHorizontal className="vipps-logo"/></p>
                    </div>
                ) : (
                    <div/>
                )}
            </div>
        </div>
    );
}


export default ProductsAvailableForPurchase;
